import Reducer from './../util/reducer'

const reducer = new Reducer()

reducer.register('AUTHENTICATE_COGNITO', (info) => {
  return {
    authenticated: info.authenticated,
    userId: info.userId
  }
})

reducer.register('AUTHENTICATE_LOGOUT', () => {
  return {
    authenticated: false,
    userId: null
  }
})

export default reducer.build()
